import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from "zod";
import { Button, Group, Modal, Select, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useCallback, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { createLayerGroup, getLayerGroupValues } from "../../reducers/layersReducer.js";
import { zod4Resolver } from "mantine-form-zod-resolver";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
export const AddLayerGroupModal = ({ opened, onClose }) => {
    const intl = useIntl();
    const groups = useAppSelector(getLayerGroupValues);
    const addGroup = useAppAction(createLayerGroup);
    const captureEvent = useCaptureEvent();
    const validate = useMemo(() => zod4Resolver(z.object({
        label: z
            .string()
            .min(1, {
            message: intl.formatMessage({
                defaultMessage: "Group name is required",
                id: "error.groupNameRequired",
            }),
        })
            .max(255, {
            message: intl.formatMessage({
                defaultMessage: "Group name is too long",
                id: "error.groupNameTooLong",
            }),
        }),
        parent: z.string().optional(),
    })), [intl]);
    const handleCreate = useCallback(({ label, parent }) => {
        const value = crypto.randomUUID();
        addGroup({
            value,
            label,
            parent,
            icon: "test",
            children: [],
        });
        captureEvent(Event.CreateLayerGroup);
        onClose();
    }, [addGroup, onClose]);
    const { onSubmit, getInputProps } = useForm({
        validateInputOnBlur: true,
        initialValues: {
            label: "",
        },
        validate,
    });
    return (_jsx(Modal, { opened: opened, onClose: onClose, title: "Add group", size: "md", children: _jsx(Stack, { children: _jsxs("form", { onSubmit: onSubmit(handleCreate), children: [_jsx(Group, { children: _jsx(TextInput, { label: intl.formatMessage({
                                defaultMessage: "Group name",
                                id: "label.groupName",
                            }), placeholder: intl.formatMessage({
                                defaultMessage: "Group name",
                                id: "label.groupName",
                            }), ...getInputProps("label") }) }), _jsx(Select, { label: intl.formatMessage({
                            defaultMessage: "Parent group",
                            id: "label.parentGroup",
                        }), data: groups, ...getInputProps("parent") }), _jsxs(Group, { gap: "md", justify: "flex-end", mt: "md", children: [_jsx(Button, { variant: "outline", onClick: onClose, children: _jsx(FormattedMessage, { id: "button.cancel", defaultMessage: "Cancel" }) }), _jsx(Button, { variant: "tertiary", type: "submit", children: _jsx(FormattedMessage, { id: "button.addNewGroup", defaultMessage: "Add new group" }) })] })] }) }) }));
};
